import { Component } from '@angular/core';
import { TranslationHelper } from '../../helpers/translation.helper';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';

@Component({
    templateUrl: './access-denied.component.html',
    styleUrls: ['../shared/error-base.component.scss', 'access-denied.component.scss'],
    standalone: false,
})
export class AccessDeniedComponent extends TranslationHelper {
  public logoPath = '../../../assets/img/frogo.svg';

  protected originURL: string;
  protected translationPath = 'accessDenied';

  constructor(
    protected _translate: TranslateService,
    private _activatedRoute: ActivatedRoute,
  ) {
    super(_translate);

    const { originURL } = this._activatedRoute.snapshot.queryParams;

    this.originURL = originURL;
  }
}
